import { Box } from '@mui/material';
import { type FC, type PropsWithChildren } from 'react';
import { useSwipeable } from 'react-swipeable';

interface SwipeComponentProps extends PropsWithChildren {
  swiped: () => void;
}

export const SwipeComponent: FC<SwipeComponentProps> = ({
  swiped,
  children,
}) => {
  const handlers = useSwipeable({
    onSwipedRight: swiped,
    onSwipedLeft: swiped,
  });

  return <Box {...handlers}>{children}</Box>;
};
